import { useEffect, useMemo } from 'react';
function useKeys(keys, handler, ref) {
    const keyList = useMemo(() => (Array.isArray(keys) ? keys : [keys]), [keys]);
    useEffect(() => {
        const element = ref.current;
        if (!element)
            return;
        const handleKeyDown = (event) => {
            if (keyList.includes(event.key)) {
                handler(event);
            }
        };
        element.addEventListener('keydown', handleKeyDown);
        return () => {
            element.removeEventListener('keydown', handleKeyDown);
        };
    }, [keyList, handler, ref]);
}
export default useKeys;
//# sourceMappingURL=useKeys.js.map